<script setup lang="ts">
import { useRouter } from 'vue-router'
import BaseButton from '@/components/common/BaseButton.vue'
import PageLayout from '@/components/layout/PageLayout.vue'
import PageHeader from '@/components/layout/PageHeader.vue'
import { PhHouse, PhMagnifyingGlass, PhArrowLeft, PhArrowCounterClockwise } from '@phosphor-icons/vue'
import logoCutout from '@/assets/images/logo-infinity-cutout.png'
import { useScrollReveal } from '@/composables'

const router = useRouter()

const { observe, isVisible, reduceMotion } = useScrollReveal({ threshold: 0.1 })
</script>

<template>
  <PageLayout class="min-h-screen flex flex-col">
    <template #navbar>
      <PageHeader transparent>
        <template #left>
          <img :src="logoCutout" alt="TalentSwap" class="h-8 w-8 sm:h-10 sm:w-10" />
        </template>
      </PageHeader>
    </template>

    <div class="flex-1 flex flex-col items-center justify-center px-4 py-12 text-center">
      <div class="w-full max-w-md space-y-8" v-observe="observe" :class="{ 'opacity-0 translate-y-8': !reduceMotion && !isVisible.has($el) }">
        <!-- 404 Illustration -->
        <div class="space-y-4">
          <div class="w-32 h-32 mx-auto rounded-2xl bg-linear-to-br from-red-500/20 to-red-500/10 flex items-center justify-center">
            <PhArrowCounterClockwise class="w-16 h-16 text-accent-red" />
          </div>
          <h1 class="text-6xl font-bold text-ink">404</h1>
          <h2 class="text-2xl font-semibold text-ink-4">Page Not Found</h2>
          <p class="text-ink-5 text-lg">The page you're looking for doesn't exist or has been moved.</p>
        </div>

        <!-- Actions -->
        <div class="space-y-3">
          <BaseButton
            variant="primary"
            size="lg"
            full-width
            @click="() => router.push('/')"
          >
            <PhHouse class="w-5 h-5 mr-2" />
            Go to Homepage
          </BaseButton>
          <BaseButton
            variant="secondary"
            size="lg"
            full-width
            @click="() => router.push('/browse/')"
          >
            <PhMagnifyingGlass class="w-5 h-5 mr-2" />
            Browse Services
          </BaseButton>
          <BaseButton
            variant="ghost"
            full-width
            @click="() => router.back()"
          >
            <PhArrowLeft class="w-5 h-5 mr-2" />
            Go Back
          </BaseButton>
        </div>

        <!-- Helpful Links -->
        <div class="pt-8 border-t border-line space-y-2">
          <p class="text-xs text-ink-6">Quick links:</p>
          <div class="flex flex-wrap justify-center gap-3 text-sm">
            <BaseButton variant="ghost" size="sm" @click="() => router.push('/browse/')">Browse Services</BaseButton>
            <BaseButton variant="ghost" size="sm" @click="() => router.push('/login/')">Sign In</BaseButton>
            <BaseButton variant="ghost" size="sm" @click="() => router.push('/register/')">Sign Up</BaseButton>
          </div>
        </div>
      </div>
    </div>
  </PageLayout>
</template>